import "lib/migrateStorage";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./assets/wasaa/wasaa-tokens.css";
import { initTheme } from "lib/theme";
import "./index.css";

import App from "./App";

initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
